import $ from "jquery";
import Swal from 'sweetalert2';
import manager from 'app/module46/component-manager.js';

window.Swal = Swal;

class Modal {

	button;
	properties;
	template;

	templateElement;

	constructor(component, elements, attributes, properties) {

		component.open = this.trigger.bind(this);

		this.button = component;
		this.properties = properties;
		this.templateElement = document.querySelector('#' + attributes['modalTemplate']);
		this.template = this.templateElement.innerHTML.replace(/=\"\"/gm, '');

		switch (attributes['trigger']) {

			default:
			case 'manual':
				this.button.addEventListener('click', this.trigger.bind(this));
				break;

			case 'auto':
			case 'automatic':
				this.trigger();
				break;

			case 'form':
				const form = this.button.querySelector('.modal__form');

				form.addEventListener('submit', (ev) => {
					ev.preventDefault();

					const fields = form.serializeArray();

					for (const field of fields) {
						this.properties.values[field.name] = field.value;
					}

					this.trigger(ev);
				});

				break;
		}
	}

	trigger(ev = null) {

		// If a dummy put the trigger on a link, we cancel the link
		if (ev) {
			ev.preventDefault();
		}

		// Fait un call ajax et remplace les tags {} par le json retournant
		const url = this.properties.ajaxValues;

		if (url) {

			// Cache le bouton en attandant la réponse ajax;
			$(this.button).hide();
			Swal.showLoading();

			manager.get(url,
				(data) => this.interpolate(data, false),
				(xhr) => console.warn(xhr.responseText),
				() => {
					$(this.button).show();
					this.open();
				});

		} else {

			this.open();
		}
	}

	open() {

		const options = this.properties.options ?? {};
		this.interpolate(this.properties.values, true);

		options.html = this.template;
		options.willOpen = this.willOpen.bind(this);
		options.didClose = this.didClose.bind(this);

		Swal.fire(options).then((result) => {

			if (result.value) {

				const href = this.properties.href;

				if (href) {
					location.href = href;
				}
			}
		});
	}

	willOpen(modal) {

		if (this.form = modal.querySelector('form')) {
			this.fillForm(this.form);
		}

		manager.execute(modal);
	}

	didClose() {
		if (this.form) {

			const shadow = document.createElement('shadow');

			shadow.innerHTML = this.template;

			const errors = shadow.querySelectorAll('.flash-message');

			for (const error of errors) {
				error.remove();
			}

			this.fillForm(shadow.querySelector('form'), true);

			this.templateElement.innerHTML = shadow.innerHTML;
		}
	}

	fillForm(form, emptyForm = null) {
		const data = this.properties.form;

		if (!data) {
			return;
		}

		emptyForm = emptyForm ?? this.properties.emptyForm;

		form.action = data['action'] ?? form.action;
		form.method = data['method'] ?? form.method;

		// form__field_error

		for (const input of form.elements) {

			let value = data[input.name];

			if (emptyForm || value !== undefined) {

				if (emptyForm) {
					value = '';
				}

				if (input.tagName === 'INPUT') {

					const type = input.type.toLowerCase();

					switch (type) {
						case 'button':
						case 'submit':
							break;
						case 'file':
							const img = document.querySelector('img#preview-' + input.id);
							if (img) {
								img.src = value;
							}
							break;
						case 'password':
							break;
						case 'radio':
						case 'checkbox':
							input.checked = value;
							break;
						case 'hidden':
							const parent = input.parentNode;
							if (parent && parent.dataset.component === 'dropdown') {
								if (emptyForm) {
									$(parent).dropdown('clear');
								} else {
									$(parent).dropdown('set selected', value);
								}
								input.value = value;
							}
							break;
						default:
							input.value = value;
							break;
					}
				} else if (input.tagName === 'TEXTAREA') {
					input.innerText = value;
				}
			}
		}
	}

	interpolate(data, cleanUp = false) {

		// Remplace les interpolations par leur valeurs
		for (const key in data) {
			this.template = this.template.replace(new RegExp("_{" + key + "}", "gm"), data[key]);
		}

		// Nettoie les interpolations restantes
		if (cleanUp) {
			this.template = this.template.replace(new RegExp("_{[^\\s]*}", "gm"), "");
		}

		return this.template;
	}
}

manager.register('modal', (component, elements, attributes, properties) => new Modal(component, elements, attributes, properties));
